import { render, staticRenderFns } from "./Percent.vue?vue&type=template&id=10bec51e&"
import script from "./Percent.vue?vue&type=script&lang=js&"
export * from "./Percent.vue?vue&type=script&lang=js&"
import style0 from "./Percent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports